import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isResourceOfType } from './annotations';
import { LeaseDetailsCard } from './LeaseDetailsCard';
import { AccountDetailsCard } from './AccountDetailsCard';
import { TemplateDetailsCard } from './TemplateDetailsCard';

const leaseDetailsCard = EntityCardBlueprint.make({
  name: 'aws-sandbox-lease-details',
  params: {
    type: 'content',
    filter: entity => isResourceOfType(entity, 'aws-sandbox-lease'),
    loader: async () => <LeaseDetailsCard />,
  },
});

const accountDetailsCard = EntityCardBlueprint.make({
  name: 'aws-sandbox-account-details',
  params: {
    type: 'content',
    filter: entity => isResourceOfType(entity, 'aws-sandbox-account'),
    loader: async () => <AccountDetailsCard />,
  },
});

// See TemplateDetailsCard.tsx — the placeholder/example for adding further
// annotation-driven resource views.
const templateDetailsCard = EntityCardBlueprint.make({
  name: 'aws-sandbox-template-details',
  params: {
    type: 'content',
    filter: entity => isResourceOfType(entity, 'sandbox-lease-template'),
    loader: async () => <TemplateDetailsCard />,
  },
});

export const resourceDetailsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [leaseDetailsCard, accountDetailsCard, templateDetailsCard],
});
